import "./Funcionalidades.css";
import Funcionalidad from "../atoms/Funcionalidad";
import funcionalidades from "../../data/funcionalidades";

export const Funcionalidades = () => {
  return (
    <div id="funcionalidades">
      <h1>Funcionalidades</h1>

      <div className="funcionalidades-container">
        {Object.entries(funcionalidades).map(([key, funcionalidad], index) => (
          <Funcionalidad funcionalidad={funcionalidad} key={key}/>
        ))}
      </div>
    </div>
  );
};

export default Funcionalidades;
